import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import AppSelector from 'AppSelector';

import ThemeProvider from './features/ThemeProvider';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

import './index.css';
import 'leaflet/dist/leaflet.css';
import 'timepicker-ui/main.css';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(MOUNT_NODE);
root.render(
  <Provider store={store}>
    <HelmetProvider>
      <ThemeProvider>
        <AppSelector />
      </ThemeProvider>
    </HelmetProvider>
  </Provider>,
);

reportWebVitals();
